export default __webpack_public_path__ + "static/media/Pseudo.546acca3.png";